import { useStaticQuery, graphql } from 'gatsby'
import { ContentModule, ContentPackage } from '../types/config'

type SiteMetadata = {
  title: string
  organization: string
  organizationSite: string
  contentModules: ContentModule[]
  contentPackages: ContentPackage[]
}

const useSiteMetadata = (): SiteMetadata => {
  const { site } = useStaticQuery(
    graphql`
      query ProductsQuery {
        site {
          siteMetadata {
            title
            organization
            organizationSite
            contentModules
            contentPackages
          }
        }
      }
    `
  )
  const {
    title,
    organization,
    organizationSite,
    contentModules,
    contentPackages,
  } = site.siteMetadata
  return {
    title,
    organization,
    organizationSite,
    contentModules: JSON.parse(contentModules) as ContentModule[],
    contentPackages: JSON.parse(contentPackages) as ContentPackage[],
  }
}

export default useSiteMetadata
